<template>
  <div style="width: 1200px;margin: 0 auto;">
    <div style="text-align: center; margin: 0 auto 40px;position: relative;width: 976px">
      <img :src="ossPath + '/pages/home/member_zone_title.png'" alt="">
    </div>
    <div class="hot-country-list-box">
      <div>
        <div style="width: 1120px; display: flex;align-items: center;margin-bottom: 10px;">
          <img style="width: 14px;height: 14px;" src="https://huodaipin-test.oss-cn-hongkong.aliyuncs.com/web/v1.0.0/pages/home/icon_member_address.png"/>
          <div class="tabs-item">热门地区</div>
          <div :class="country==item ? 'tabs-item is-active' : 'tabs-item'" v-for="(item,index) in countryList" :key="index" @click="country = item; getHotMemberZone();">{{item}}</div>
        </div>
        <div style="width: 1120px; display: flex;align-items: center;margin-bottom: 10px;">
          <img style="width: 14px;height: 14px;" src="https://huodaipin-test.oss-cn-hongkong.aliyuncs.com/web/v1.0.0/pages/home/icon_member_lanhuo.png"/>
          <div class="tabs-item">揽货城市</div>
          <div :class="city==item ? 'tabs-item is-active' : 'tabs-item'" v-for="(item,index) in collectionCityList" :key="index" @click="city = item; getHotMemberZone();">{{item}}</div>
        </div>
        <div style="width: 1120px; display: flex;align-items: center;margin-bottom: 10px;">
          <img style="width: 14px;height: 14px;" src="https://huodaipin-test.oss-cn-hongkong.aliyuncs.com/web/v1.0.0/pages/home/icon_member_wuliu.png"/>
          <div class="tabs-item">业务类型</div>
          <div :class="businessType==item ? 'tabs-item is-active' : 'tabs-item'" v-for="(item,index) in businessTypeList" :key="index" @click="businessType = item; getHotMemberZone();">{{item}}</div>
        </div>
        <protected-content>
          <div v-logoLoading="lableDataloading" element-loading-text="查询中..." element-loading-spinner="el-icon-loading" element-loading-background="#f5f5f5" style="width: 100%; height: 100%; min-height: 401px;">
            <el-row v-if="list.length">
              <el-col class="member-item" v-for="(o, index) in list" :key="index">
                <el-card shadow="never" :body-style="{ padding: '0px', borderRadius: '8px'}">
                  <div style="width: 228px; height: 171px; display: flex; justify-content: center; align-items: center;position: relative;">
                    <img style="max-width: 228px; max-height: 171px; object-fit: cover;"
                      :src="o.logo && o.logo.length ? o.logo : 'https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png'"
                      @click="gotoMemberZoneDetail(o.id)"/>
                    <img
                      :src="ossPath + '/pages/memberZone/VIP2_gif.gif'"
                      alt=""
                      style="position: absolute; top: -1px; left: 0;width: 80px;height: 22px;"
                      v-if="o.memberFlag"
                    >
                    <img
                      :src="ossPath + '/pages/memberZone/not_vip1.gif'"
                      alt=""
                      style="position: absolute; top: -1px; left: 0;width: 80px;height: 22px;"
                      v-else
                    >
                    <div class="vip-tip" v-if="o.memberFlag">
                      <img :src="ossPath+'/pages/memberZone/icon.png'" alt="">享有增值服务权益
                    </div>
                  </div>
                  <div class="content">
                    <span class="ellipsis title" @click="gotoMemberZoneDetail(o.id)" style="-webkit-line-clamp: 1;">{{ o.corporationShortName }}</span>
                    <div class="bottom clearfix">
                      <el-popover
                        placement="rigth-start"
                        width="167"
                        trigger="hover"
                        :content="o.shortDescription">
                        <div slot="reference" class="ellipsis desc">{{ o.shortDescription }}</div>
                      </el-popover>
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <div v-else style="margin-top: 80px;">
              <div class="head_Image">
                <div>
                  <img
                    :src="ossPath + '/pages/queryPrice/noprice_new.png'"
                    alt="暂无数据"
                  />
                </div>
              </div>
              <div class="tipText">
                <div>
                  <p style="color: #141414">暂无数据</p>
                </div>
              </div>
            </div>
            <div style="position: relative" v-if="list.length">
              <div class="look-private-line-quotation">
                <div class="look-btn" @click="gotoMemberZone()">
                  查看更多
                  <img :src="ossPath + '/pages/home/country/icon_arrow_now.png'" alt="" style="margin-left: 4px;">
                </div>
              </div>
            </div>
          </div>
        </protected-content>
      </div>
    </div>
  </div>
</template>

<script>
import {sendCustomerOperationRecord} from "@/assets/js/utils";
import Utils from "../../../../../common/util.js";
import { isObject } from "my-tools-kit";
import ProtectedContent from "../../../../../common/protectedContent.vue";
import { ossPath } from '../../../../../devParams.js'
export default {
  name: "homeHotMemberZone",
  // props: {
  //   list:{
  //     type:Array,
  //     default:()=>[]
  //   },
  // },
  components: {
    ProtectedContent
  },
  computed: {
  },
  data() {
    const ossPath = this.ossPath;
    return {
      list: [],
      lableDataloading: false,
      countryList: ['全部', '北美', '欧洲', '拉美', '日韩', '东南亚', '南亚', '中东', '非洲', '澳洲', '其他'],
      country: '全部',
      businessTypeList: ['全部', '海运', '空运', '陆运', '铁路', '快递', '专线小包', '卡航', '海运整柜', 'COD', '集运', '超大件', '海外仓', '中港', '其他'],
      collectionCityList: ['全部', '广州', '义乌', '深圳', '东莞'],
      businessType:'全部',
      city: '全部',
      ossPath
    }
  },
  methods: {
    /**
     * 获取 会员专区前15条数据
     */
    getHotMemberZone () {
      this.lableDataloading = true;
      const data = {
        country: this.country === '全部' ? '' : this.country,
        businessType: this.businessType === '全部' ? '' : this.businessType,
        city: this.city === '全部' ? '' : this.city,
        size: 15
      }
      this.axios.post(`/memberZone/showTopList`, data)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message))
          return res;
        })
        .then(res=>{
          this.lableDataloading = false;
          console.log('获取 会员专区前15条数据: ', JSON.stringify(res))
          this.list = res.datas|| []
        })
        .catch(res => {
          this.lableDataloading = false;
        })
    },
    gotoMemberZone() {
      const num = 16;
      this.$store.commit("changeactive", num)
      this.$store.commit("emptyList") //清空个人中心标签
      Utils.$emit("changeNav", num)
      sendCustomerOperationRecord("会员专区");
      this.$router.push({ name: "MemberZone" })
      this.$store.commit("changeSetType", true)
      this.$store.commit("changeLogoshow", false) //关闭logo
    },
    gotoMemberZoneDetail(id) {
      const num = 16;
      this.$store.commit("changeactive", num)
      this.$store.commit("emptyList") //清空个人中心标签
      Utils.$emit("changeNav", num)
      sendCustomerOperationRecord("会员专区");
      sessionStorage.setItem("memberZoneId", id)
      this.$router.push({ name: "MemberZoneDetail" })
      this.$store.commit("changeSetType", true)
      this.$store.commit("changeLogoshow", false) //关闭logo
    },
  },
  created() {
   
  },
  mounted() {
    this.getHotMemberZone()
  }
}
</script>

<style lang="less" scoped>
.look-private-line-quotation{
  display: flex;
  align-items: center;
  justify-content: center;
  .look-btn {
    box-sizing: border-box;
    height: 36px;
    line-height: 36px;
    width: 140px;
    background: #FF4D01;
    text-align: center;
    font-size: 16px;
    border-radius: 100px;
    color: white;
    user-select: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
/deep/ .el-card {
  border-radius: 8px;
}
.member-item {
  cursor: pointer;
  width: 228px; 
  height: 271px; 
  margin-right: 12px; 
  margin-bottom: 20px;
  .image {
    width: 228px;
    height: 171px;
  }
  .content {
    background-color: #F9F9F9; 
    height: 80px; 
    padding: 10px;
    .title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 16px;
      color: #333333;
      line-height: 22px;
      text-align: left;
      font-style: normal;
    }
    .desc {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #555555;
      line-height: 20px;
      text-align: left;
      font-style: normal;
      width: 209px;
    }
  }
  .ellipsis {
    overflow: hidden; 
    text-overflow: ellipsis; 
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
.tabs-item{
  margin-left: 4px;
  min-width: 68px;
  height: 28px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #555555;
  line-height: 28px;
  text-align: center;
  font-style: normal;
  cursor: pointer;
  user-select: none;
  flex-grow: 0;
  &.is-active{
    color: #FFF;
    cursor: default;
    background: #FF4D01;
    border-radius: 4px;
  }
  &:first-child {
    margin-left: 0;
  }
}
.head_Image {
  width: 100%;
  display: flex;
  justify-content: center;

  div {
    // width: 385px;
    // height: 208px;
  }
}

.tipText {
  display: flex;
  justify-content: center;

  div {
    width: 418px;
    // height: 76px;
    margin-top: 24px;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    color: #666;
  }
}
.vip-tip {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 26px;
  background-color: rgba(46, 35, 1, .5);
  font-size: 12px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  img {
    margin-left: 10px;
    margin-right: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/homeHotMemberZone/index.vue